import React from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export default props => {
    const { money } = props
    const global = useSelector(state => state.global)
    const { config, country } = global

    useEffect(() => {
        let zipScript = document.getElementById('zip-message-script')
        const head = document.getElementsByTagName('head')[0]
        if (!zipScript) {
            const script = document.createElement('script')
            script.id = 'zip-message-script'
            script.type = 'text/javascript'
            script.src = `https://cdn.us.zip.co/v1/quadpay.js`
            script.async = true
            head.appendChild(script)
        }
    }, [])

    return country === 'US' && money?.currency === 'USD' ? <quadpay-widget-v3 displayMode="logoFirst" size="90%" amount={money?.amount} merchantId={config?.zip?.merchantId} ></quadpay-widget-v3> : <></>
}